import { render, staticRenderFns } from "./BlockFile.vue?vue&type=template&id=4b624bc0&"
import script from "./BlockFile.vue?vue&type=script&lang=js&"
export * from "./BlockFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports